export default __webpack_public_path__ + "static/media/TwoStars.8f13152d.svg";